import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAut-8PIAK8DujZxqZXq7xvS2bDE2OufNY",
  authDomain: "gogram-56b75.firebaseapp.com",
  projectId: "gogram-56b75",
  storageBucket: "gogram-56b75.firebasestorage.app",
  messagingSenderId: "730489798566",
  appId: "1:730489798566:web:c1470906d22df59f9bd967"
};

// Initialize Firebase app only once
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Export the singleton auth instance
export const auth = getAuth(app);
